import history from './history';
import store from './store';

export { history, store };



// WEBPACK FOOTER //
// ./src/helpers/index.js